import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './history.css'
import "../Home/home.css"
import ApiService from '../../services/apiService';
import moment from 'moment/moment';
import GameHeader from '../header/header';

const HistoryPage = () => {
    const [activeFilter, setActiveFilter] = useState('Completed');
    const [rowdata, setRowData] = useState([]);
    const [userData, setUserData] = useState();
    const apiService = new ApiService();
    let navigate = useNavigate();
    const location = useLocation();
    const item = location.state;
    useEffect(() => {
        if (item?.gmeres.length > 0) {
            const items = JSON.parse(localStorage.getItem('user'));
            setActiveFilter('Pending')
            fetchuserData(items)
        } else {
            const items = JSON.parse(localStorage.getItem('user'));
            if (items) {
                fetchuserData(items)
            }
        }
    }, [activeFilter]);
    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('userId ', items?.nameid);
            // params.append('userId', 23);
            // const res = await apiService.getApiParamater('GET_HISTORY', `${23}`);
            const res = await apiService.getApiParamater('GET_HISTORY', `${items?.nameid}?status=${activeFilter}`);
            setRowData(res?.data);



            if (activeFilter === 'Pending') {
                setRowData(null);
                const params = new URLSearchParams();
                params.append('id', items?.nameid);
                const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
                setUserData(res?.data[0]);


                const chParams = new URLSearchParams();
                chParams.append('userId', res?.data[0]?.id);
                chParams.append('gameLevel', res?.data[0]?.playedGames + 1);
                const GamRes = await apiService.getApiParamater('CHECK_BALANCE', `?${chParams.toString()}`);
                const Params = new URLSearchParams();
                Params.append('name', item?.gmeres[0]?.gameName || GamRes?.data[0]?.gameName);
                const GameRes = await apiService.getApiParamater('GAME_LIST', `?${Params.toString()}`);
                let games = GameRes?.data?.filter(g => g.price === (item?.gmeres[0]?.gamePrice || GamRes?.data[0]?.gamePrice))
                let level = res?.data[0]?.memberLevel
                let gameprice = games[0]?.price
                if (level === 1) {
                    let level1 = 3
                    let commission = (gameprice * level1) / 100
                    if (games?.[0]) {
                        const combinedData = games.map(match => ({
                            ...games[0],  // Base object
                            commission: commission,
                            actualbalance: item?.gmeres[0]?.actualBalance || games[0]?.actualBalance
                        }));
                        setRowData(combinedData);
                    } else {
                        setRowData(null);
                    }
                } else {
                    let level1 = 6
                    let commission = (gameprice * level1) / 100
                    if (games?.[0]) {
                        const combinedData = games?.map(match => ({
                            ...games[0],  // Base object
                            ...match,
                            commission: commission,
                            actualbalance: item?.gmeres[0]?.actualBalance || games[0]?.actualBalance
                        }));

                        setRowData(combinedData);
                    } else {
                        setRowData(null);
                    }
                }
            }

        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    }

    const startcarrier = async () => {
        let rowData = rowdata[0]
        debugger
        navigate(`/Play`, { state: { userData, rowData } });
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className='mx-5'>
                <h2 className="text-center pb-3 mt-lg-4">History</h2>
                <div className="filter-buttons mb-4 d-flex justify-content-between">
                    {['Completed', 'Pending'].map(label => (
                        <button
                            key={label}
                            onClick={() => setActiveFilter(label)}
                            className={activeFilter === label ? 'active' : ''}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                {/* <p className="text-end me-2">{rowData.length} Records</p> */}
                {activeFilter === 'Pending' ?
                    <div className='center'>
                        {rowdata?.map((item, index) => (
                            <div className="history-card w-lg-50 " key={index}>
                                {/* <div className="status-tag">{item.status}</div> */}
                                <div className='my-3'>
                                    <img src={item?.thumb} className='imgbox' />
                                </div>
                                <h5>{item?.name}</h5>
                                <div className="">
                                    <div className='transaction-row'>Price (USDC): <span className="value">{item?.price?.toFixed(2)}</span></div>
                                    <div className='transaction-row'> Commission (USDC): <span className="value">{item?.commission?.toFixed(2)}</span></div>
                                </div>
                                <div className="date-time">{moment(item?.createTime).format("MMM Do YY")}</div>
                                <div className='center p-3'>
                                    <button class="btn btn-scondary w-50 btn-lg " type="button" onClick={startcarrier}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className=''>
                        {rowdata?.map((item, index) => (
                            <div className="history-card" key={index}>
                                {/* <div className="status-tag">{item.status}</div> */}
                                <div className='my-3'>
                                    <img src={item?.gameThumb} className='imgbox' />
                                </div>
                                <h5>{item?.gameName}</h5>
                                <div className="transaction-row">
                                    <div>Price (USDC): <span className="value">{item?.gamePrice?.toFixed(2)}</span></div>
                                    <div>Commission (USDC): <span className="value">{item?.commission?.toFixed(2)}</span></div>
                                </div>
                                <div className="date-time">{moment(item?.createTime).format("MMM Do YY")}</div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
};

export default HistoryPage;
